import React from "react";

/**
 * The row above each table: the view switch on the left (owned by the widget,
 * handed down as `controls`), and whatever the view has to say about itself —
 * its count — on the right. Each view renders it, because each view owns the
 * query its count comes from.
 */
export const ControlsRow = ({ controls, children }) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1.6rem", marginBottom: 8 }}>
    {controls}
    {children}
  </div>
);
